import { createAction, createErrorAction } from '../../../actions/actionCreator';
import { ActionsType } from '@card/types';

export enum EstablishmentsActionType {
  AssignShop = 'establishments/assign_shop',
  AssignSuccess = 'establishments/assign_shop_success',
  AssignFailed = 'establishments/assign_shop_failed',
  AssignAllEstablishments = 'establishments/assign_all_establishments',
  AssignAllEstablishmentsFailed = 'establishments/assign_all_establishments_failed',
  AssignAllEstablishmentsSuccess = 'establishments/assign_all_establishments_success'
}

type assignationToSendType = {
  assignations: {
    establishmentId: string;
    shopId: string;
  }[];
  credentialId: string;
  assignAll: boolean;
};

export const EstablishmentsActions = {
  assignShop: (assignShopParams: {
    establishmentId: string;
    shopId: string;
    credentialId: string;
  }) => createAction(EstablishmentsActionType.AssignShop, assignShopParams),
  assignShopSuccess: () => createAction(EstablishmentsActionType.AssignSuccess),
  assignShopFailed: (errorMessage: string) =>
    createErrorAction(EstablishmentsActionType.AssignFailed, errorMessage),
  assignAllEstablishments: (assignationsToSend: assignationToSendType) =>
    createAction(EstablishmentsActionType.AssignAllEstablishments, assignationsToSend),
  assignAllEstablishmentsSuccess: () =>
    createAction(EstablishmentsActionType.AssignAllEstablishmentsSuccess),
  assignAllEstablishmentsFailed: (errorMessage: string) =>
    createErrorAction(EstablishmentsActionType.AssignAllEstablishmentsFailed, errorMessage)
};

export type EstablishmentsAction = ActionsType<typeof EstablishmentsActions>;
